import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'

const styles = require('./styles.scss')

interface Props {
  asset: React.ReactNode
  children?: React.ReactNode
  title: string
}

const EmptyStatePane = (props: Props) => (
  <ThemeConsumer>
    {({ backdropStyles, colorPrimary }) => (
      <div className={styles.emptyStateInnerContainer}>
        <div
          className={classnames(
            styles.emptyStateAsset,
            css`
              background: ${backdropStyles.backgroundColor};
              svg path {
                fill: ${colorPrimary};
              }
            `,
          )}
        >
          {props.asset}
        </div>
        <div className={styles.emptyStateContent}>
          <h2>{props.title}</h2>
          {props.children}
        </div>
      </div>
    )}
  </ThemeConsumer>
)

export default EmptyStatePane
